module.exports = __webpack_public_path__ + "static/media/prezi.c94a2b23.png";